import React from "react";
import { Grid, Skeleton } from "@mui/material";
import { MuiBox } from "components/atoms";

const FolderPageSkeleton = ({
    folderCount = 4,
    fileCount = 4,
    showBreadcrumb = true,
}) => {

    return (
        <MuiBox
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "24px",
                width: "100%",
            }}
        >
            {/* Breadcrumb */}
            {showBreadcrumb && (
                <MuiBox
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                    }}
                >
                    <Skeleton variant="text" width={90} height={40} />
                    <Skeleton
                        variant="rounded"
                        width={22}
                        height={22}
                        sx={{ borderRadius: "2px" }}
                    />
                    <Skeleton variant="text" width={120} height={40} />
                    <Skeleton
                        variant="rounded"
                        width={22}
                        height={22}
                        sx={{ borderRadius: "2px" }}
                    />
                    <Skeleton variant="text" width={100} height={40} />
                </MuiBox>
            )}

            <MuiBox
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    width: {
                        xs: "100%",
                        md: "fit-content",
                    },
                    flexWrap: {
                        xs: "wrap",
                        md: "nowrap",
                    },
                    flexShrink: {
                        xs: 1,
                        md: 0,
                    },
                }}
            >
                <Skeleton
                    variant="rounded"
                    width={120}
                    height={40}
                    sx={{ borderRadius: "8px" }}
                />
                <Skeleton
                    variant="rounded"
                    width={120}
                    height={40}
                    sx={{ borderRadius: "8px" }}
                />
                <Skeleton
                    variant="rounded"
                    width={120}
                    height={40}
                    sx={{ borderRadius: "8px" }}
                />
            </MuiBox>



            {/* Folders */}
            <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>


                <Grid container spacing={3}>
                    {Array.from({ length: folderCount }).map((_, index) => (
                        <Grid item key={`folder-${index}`} xs={12} sm={6} md={4} lg={3}>
                            <MuiBox
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "12px",
                                    p: "12px 14px",
                                    borderRadius: "12px",
                                    bgcolor: "background.blue200",
                                    minHeight: "64px",
                                }}
                            >
                                <MuiBox
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        minWidth: 0,
                                        flex: 1,
                                    }}
                                >
                                    <Skeleton
                                        variant="rounded"
                                        width={28}
                                        height={28}
                                        sx={{ borderRadius: "6px", flexShrink: 0 }}
                                    />
                                    <MuiBox
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                            minWidth: 0,
                                            flex: 1,
                                        }}
                                    >
                                        <Skeleton variant="text" width="70%" height={16} />
                                        <Skeleton variant="text" width="50%" height={12} />
                                    </MuiBox>
                                </MuiBox>
                                <Skeleton
                                    variant="circular"
                                    width={20}
                                    height={20}
                                    sx={{ flexShrink: 0 }}
                                />
                            </MuiBox>
                        </Grid>
                    ))}
                </Grid>
            </MuiBox>

            {/* Files */}
            <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                <Grid container spacing={3}>
                    {Array.from({ length: fileCount }).map((_, index) => (
                        <Grid item key={`file-${index}`} xs={12} sm={6} md={4} lg={3}>
                            <MuiBox
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: "12px",
                                    border: "1px solid",
                                    borderColor: "background.gray400",
                                    overflow: "hidden",
                                    bgcolor: "background.white",
                                }}
                            >
                                <Skeleton
                                    variant="rounded"
                                    width="100%"
                                    height={200}
                                    sx={{ borderRadius: 0 }}
                                />
                                <MuiBox
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "8px",
                                        p: "10px 12px",
                                    }}
                                >
                                    <MuiBox
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                            minWidth: 0,
                                            flex: 1,
                                        }}
                                    >
                                        <Skeleton variant="text" width="75%" height={16} />
                                        <Skeleton variant="text" width="50%" height={12} />
                                    </MuiBox>
                                    <Skeleton
                                        variant="circular"
                                        width={20}
                                        height={20}
                                        sx={{ flexShrink: 0 }}
                                    />
                                </MuiBox>
                            </MuiBox>
                        </Grid>
                    ))}
                </Grid>
            </MuiBox>
        </MuiBox>
    );
};

export default FolderPageSkeleton;